import { render, staticRenderFns } from "./h-info.vue?vue&type=template&id=87e1e1de&scoped=true"
import script from "./h-info.vue?vue&type=script&lang=js"
export * from "./h-info.vue?vue&type=script&lang=js"
import style0 from "./h-info.vue?vue&type=style&index=0&id=87e1e1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e1e1de",
  null
  
)

export default component.exports